var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "800", eager: "" },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              attrs: {
                color: _vm.editMode ? "yellow darken-3" : "primary darken-3",
                dark: "",
                dense: "",
                flat: ""
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.stockId) + " Units")])]
          ),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  disabled: _vm.editMode,
                                  items: _vm.unitIndexList,
                                  loading: _vm.unitIndexGetting,
                                  dense: "",
                                  label: "unit",
                                  "item-value": "id",
                                  "item-text": "description",
                                  "return-object": false,
                                  "error-messages":
                                    _vm.stockUnitStorePostErrors.unit
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function({ item }) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(item.id || item))
                                        ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        item.id
                                          ? _c(
                                              "span",
                                              { staticClass: "primary--text" },
                                              [
                                                _vm._v(" " + _vm._s(item.id)),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "ml-2 blue-grey--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.description)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c("span", [_vm._v(_vm._s(item))])
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.unit,
                                  callback: function($$v) {
                                    _vm.unit = $$v
                                  },
                                  expression: "unit"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  label: "srp",
                                  type: "number",
                                  "error-messages":
                                    _vm.stockUnitStorePostErrors.srp
                                },
                                model: {
                                  value: _vm.srp,
                                  callback: function($$v) {
                                    _vm.srp = $$v
                                  },
                                  expression: "srp"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.editMode
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        dense: "",
                                        dark: "",
                                        block: "",
                                        color: "green",
                                        loading: _vm.stockUnitStorePosting
                                      },
                                      on: { click: _vm.storeUnit }
                                    },
                                    [_c("span", [_vm._v("Add")])]
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dense: "",
                                                dark: "",
                                                block: "",
                                                color: "yellow darken-3",
                                                loading:
                                                  _vm.stockUnitStorePosting
                                              },
                                              on: { click: _vm.updateUnit }
                                            },
                                            [_c("span", [_vm._v("Update")])]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dense: "",
                                                dark: "",
                                                block: "",
                                                color: "red"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.defaultData = {}
                                                }
                                              }
                                            },
                                            [_c("span", [_vm._v("Cancel")])]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "9" } },
                    [
                      _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Unit")]),
                                    _c("th", [_vm._v("SRP")]),
                                    _c("th", [_vm._v("Config")])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm.stockUnitGetting
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-center",
                                              attrs: { colspan: "3" }
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  size: "20",
                                                  color: "primary",
                                                  indeterminate: ""
                                                }
                                              }),
                                              _vm._v("Loading...")
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._l(_vm.stockUnitList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [_vm._v(_vm._s(item.unit))]),
                                        _c("td", [
                                          _vm._v(_vm._s(item.srp.phpFormat()))
                                        ]),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "yellow darken-3",
                                                  text: "",
                                                  dense: "",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.defaultData = item
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-pencil")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }